/*
  ============================================================
  carrinho.js — Drawer (carrinho lateral) Yezu
  ============================================================
  - Ao adicionar ao carrinho (qualquer form add-to-cart), faz o add
    via AJAX e ABRE o drawer (em vez de recarregar/ir para /cart).
  - Clicar no ícone de carrinho (links para /cart) também abre o drawer.
  - Quantidade (+/-) e remover dentro do drawer via /cart/change.js.
  - Barra de frete grátis, previsão de entrega e totais.
  - Fallback sem JS: o form envia nativamente para /cart/add.
*/
(function () {
  'use strict';

  var drawer;

  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function money(cents){ return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
  function updateCounts(n){ document.querySelectorAll('[data-cart-count]').forEach(function (el){ el.textContent = n; }); }
  function fetchCart(){ return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r){ return r.json(); }); }

  function openDrawer(){ if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer(){ if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  var MESES = ['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];
  function fmtDate(d){ return d.getDate() + ' de ' + MESES[d.getMonth()]; }
  function addBusinessDays(days){ var d = new Date(); var added = 0; while (added < days) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; } return d; }

  function q(sel){ return drawer.querySelector(sel); }

  function render(cart){
    if (!drawer) return;
    updateCounts(cart.item_count);
    q('[data-yzd-count]').textContent = cart.item_count;
    q('[data-yzd-itemword]').textContent = cart.item_count === 1 ? 'item' : 'itens';

    var items = q('[data-yzd-items]');
    var empty = q('[data-yzd-empty]');
    var foot = q('[data-yzd-foot]');
    var delivery = q('[data-yzd-delivery]');
    var ship = q('[data-yzd-ship]');

    if (cart.item_count === 0) {
      items.innerHTML = '';
      empty.hidden = false; foot.hidden = true; delivery.hidden = true; if (ship) ship.hidden = true;
      return;
    }
    empty.hidden = true; foot.hidden = false;

    items.innerHTML = cart.items.map(function (it) {
      var variant = (it.variant_title && it.variant_title !== null) ? '<p class="yzd__variant">' + it.variant_title + '</p>' : '';
      var was = (it.original_line_price > it.final_line_price) ? '<s class="yzd__was">' + money(it.original_line_price) + '</s>' : '';
      var img = it.image ? '<img class="yzd__thumb" src="' + it.image + '" alt="" loading="lazy">' : '<span class="yzd__thumb"></span>';
      return '<div class="yzd__item" data-key="' + it.key + '">' +
        img +
        '<div class="yzd__mid">' +
          '<p class="yzd__name">' + it.product_title + '</p>' + variant +
          '<div class="yzd__qty"><button type="button" data-yzd-minus aria-label="Diminuir">&minus;</button><span>' + it.quantity + '</span><button type="button" data-yzd-plus aria-label="Aumentar">+</button></div>' +
        '</div>' +
        '<div class="yzd__pr"><span class="yzd__now">' + money(it.final_line_price) + '</span>' + was + '<button type="button" class="yzd__rm" data-yzd-remove>Remover</button></div>' +
      '</div>';
    }).join('');

    // Barra de frete gratis
    var free = parseInt(drawer.getAttribute('data-free-shipping'), 10) || 0;
    if (ship) {
      if (free > 0) {
        ship.hidden = false;
        var pct = Math.min(100, Math.round(cart.total_price / free * 100));
        q('[data-yzd-fill]').style.width = pct + '%';
        q('[data-yzd-shipgoal]').textContent = money(free);
        var msg = q('[data-yzd-shipmsg]');
        if (cart.total_price >= free) { msg.innerHTML = 'Voce ganhou <b>frete gratis</b>! 🎉'; }
        else { msg.innerHTML = 'Faltam <b>' + money(free - cart.total_price) + '</b> para o <b>frete gratis</b>'; }
      } else { ship.hidden = true; }
    }

    // Previsao de entrega
    var dmin = parseInt(drawer.getAttribute('data-delivery-min'), 10) || 5;
    var dmax = parseInt(drawer.getAttribute('data-delivery-max'), 10) || 9;
    delivery.hidden = false;
    delivery.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>' +
      '<div><b>Chegara entre ' + fmtDate(addBusinessDays(dmin)) + ' e ' + fmtDate(addBusinessDays(dmax)) + '</b><br><span>Confira o prazo exato no checkout.</span></div>';

    // Totais
    q('[data-yzd-subtotal]').textContent = money(cart.original_total_price);
    var discrow = q('[data-yzd-discrow]');
    if (cart.total_discount > 0) { discrow.hidden = false; q('[data-yzd-disc]').textContent = '- ' + money(cart.total_discount); }
    else { discrow.hidden = true; }
    q('[data-yzd-total]').textContent = money(cart.total_price);
    q('[data-yzd-pay]').textContent = drawer.getAttribute('data-pay-text') || '';
  }

  function refreshAndRender(open){ return fetchCart().then(function (c){ render(c); if (open) openDrawer(); }); }

  function changeLine(key, qty){
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r){ return r.json(); })
      .then(function (c){ render(c); })
      .catch(function () {});
  }

  // Intercepta qualquer add-to-cart -> abre o drawer
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form[action$="/cart/add"], form[data-type="add-to-cart-form"]')) return;
    event.preventDefault();
    var button = form.querySelector('[type="submit"], [name="add"]');
    if (button) button.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r){ if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (){ return refreshAndRender(true); })
      .catch(function (){ form.submit(); })
      .finally(function (){ if (button) button.removeAttribute('aria-busy'); });
  });

  ready(function () {
    drawer = document.getElementById('carrinho');
    if (!drawer) return;

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-yzd-close]')) { closeDrawer(); return; }

      // Confirma o cupom (apenas feedback visual; a validacao e no checkout Yampi)
      if (e.target.closest('[data-yzd-coupon-apply]')) {
        var ci = q('[data-yzd-coupon]'); var ok = q('[data-yzd-coupon-ok]');
        var code = (ci && ci.value || '').trim();
        if (ok) { ok.hidden = !code; ok.textContent = code ? ('Cupom "' + code + '" sera aplicado no checkout.') : ''; }
        return;
      }

      // Finalizar: leva o cupom (se houver) para o checkout Yampi via /cart
      if (e.target.closest('[data-yzd-checkout]')) {
        e.preventDefault();
        var cEl = q('[data-yzd-coupon]');
        var coupon = (cEl && cEl.value || '').trim();
        window.location.href = '/cart?goyampi=1' + (coupon ? '&cupom=' + encodeURIComponent(coupon) : '');
        return;
      }

      var item = e.target.closest('.yzd__item');
      if (!item) return;
      var key = item.getAttribute('data-key');
      var cur = parseInt(item.querySelector('.yzd__qty span').textContent, 10) || 1;
      if (e.target.closest('[data-yzd-plus]')) changeLine(key, cur + 1);
      else if (e.target.closest('[data-yzd-minus]')) changeLine(key, Math.max(0, cur - 1));
      else if (e.target.closest('[data-yzd-remove]')) changeLine(key, 0);
    });

    // Icone/links de carrinho abrem o drawer (exceto o "Finalizar compra",
    // que leva para /cart, onde o Yampi assume o checkout).
    document.querySelectorAll('a[href$="/cart"]:not([data-yzd-checkout]), [data-cart-toggle]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); refreshAndRender(true); });
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    // Ao chegar em /cart vindo do drawer (?goyampi=1), redireciona automaticamente
    // para o checkout do Yampi, usando a URL que o proprio YampiSnippet ja calcula
    // (window.yampiCheckoutUrl). Se nao ficar pronto em ~10s, mostra o carrinho.
    if (/\/cart$/.test(location.pathname) && /[?&]goyampi=1/.test(location.search)) {
      var cm = location.search.match(/[?&]cupom=([^&]+)/);
      var cupom = cm ? decodeURIComponent(cm[1]) : '';
      var tries = 0;
      var iv = setInterval(function () {
        if (window.yampiCheckoutUrl) {
          clearInterval(iv);
          var u = window.yampiCheckoutUrl;
          if (cupom) { u += (u.indexOf('?') > -1 ? '&' : '?') + 'coupon=' + encodeURIComponent(cupom); }
          window.location.href = u;
        } else if (++tries > 50) { clearInterval(iv); }
      }, 200);
    }

    fetchCart().then(function (c) { updateCounts(c.item_count); }).catch(function () {});
  });
})();
